var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCerrarSesion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-cerrar-sesion"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cerrar-sesion",
    clipPath: "url(#clip-cerrar-sesion)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2106",
    "data-name": "Grupo 2106",
    transform: "translate(-9.821 -12.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_813",
    "data-name": "Trazado 813",
    d: "M0,0H124.988V124.988H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_799",
    "data-name": "Trazado 799",
    d: "M99.352,80.553h-6.6a.939.939,0,0,0-.943.91v7.329H14.487v-74.6H91.808v7.329a.939.939,0,0,0,.943.91h6.6a.923.923,0,0,0,.943-.91V9.639A3.686,3.686,0,0,0,96.549,6H9.772A3.692,3.692,0,0,0,6,9.639v83.7A3.692,3.692,0,0,0,9.772,96.98H96.523a3.692,3.692,0,0,0,3.772-3.639V81.463A.923.923,0,0,0,99.352,80.553Zm2.279-29.821L84.212,37.464a1,1,0,0,0-1.6.758v9H44.058a.972.972,0,0,0-.969.96V54.8a.972.972,0,0,0,.969.96H82.614v9a1,1,0,0,0,1.6.758L101.63,52.248a.967.967,0,0,0,0-1.516Z",
    transform: "translate(-4.193 -1.675)",
    fill: "#6c637b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarSesion);
export default __webpack_public_path__ + "static/media/cerrar-sesion.e71560eeeddcb9d59eace7ef0f7a5324.svg";
export { ForwardRef as ReactComponent };